export const MAX_BOOK_APPOINTMENT_YEARS = 2;

export const ROUND_BOOK_APPOINTMENT_START_TO_NEAREST_MINUTES = 30;
